module.exports = __webpack_public_path__ + "static/media/UN-03.e15923db.jpg";